<dp-progress-bar></dp-progress-bar>
<dp-main-nav>
  <router-outlet></router-outlet>
</dp-main-nav>